import React from 'react';
import { connect } from 'react-redux';

class EngineHtml extends React.Component {
  state = { url: '', loading: true, lesson: 'Unit-01-HTML' };

  componentDidMount() {
    this.buildLink();
  }

  buildLink = () => {
    const { user } = this.props;
    if (!user) {
      this.setState({ loading: false });
      return;
    }
    // Base da IDE HTML (ajuste se mudar)
    const base = 'https://ide.supergeeks.school/api/integration/user';
    const params = new URLSearchParams({
      user: user.username || user.id,
      name: (user.name || '') + (user.lastName ? ' ' + user.lastName : ''),
      lesson: this.state.lesson,
      password: user.birthDate || '0000-00-00',
      email: user.email || '',
      ops: '1'
    });
    const url = `${base}?${params.toString()}`;
    this.setState({ url, loading: false });
  };

  handleLessonChange = (e) => {
    this.setState({ lesson: e.target.value }, this.buildLink);
  };

  render() {
    const { url, loading, lesson } = this.state;
    return (
      <div style={{ height: '100vh', background: '#111', color: '#fff', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '8px 16px', background: '#1f1f1f', display: 'flex', alignItems: 'center' }}>
          <strong style={{ marginRight: 16 }}><i className="fas fa-code mr-2" />IDE HTML</strong>
          <div style={{ marginLeft: 'auto', fontSize: 12, opacity: 0.7 }}>
            Gerando link seguro com seus dados
          </div>
        </div>
        <div style={{ flex: 1 }}>
          {loading && (
            <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100%', flexDirection:'column' }}>
              <div className="spinner-border text-light mb-3" role="status" />
              <span>Carregando...</span>
            </div>
          )}
          {!loading && url && (
            <iframe
              title="IDE HTML"
              src={url}
              style={{ width:'100%', height:'100%', border:0, background:'#1b1b1b' }}
              allow="camera; microphone"
            />
          )}
          {!loading && !url && (
            <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100%' }}>
              <span>Não foi possível gerar o link.</span>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default connect(state => ({ user: state.user }))(EngineHtml);